// Override theme's mobile navigation to use our custom mobile menu
document.addEventListener('DOMContentLoaded', function() {
  // Use capture phase to intercept clicks before theme's handler
  document.addEventListener('click', function(evt) {
    const toggleButton = evt.target.closest('.mobile-nav-toggle');
    
    if (toggleButton) {
      evt.preventDefault();
      evt.stopPropagation();
      evt.stopImmediatePropagation();
      
      const mobileMenu = document.querySelector('mobile-menu');
      if (mobileMenu && typeof mobileMenu.toggle === 'function') {
        mobileMenu.toggle();
      }
      
      return false;
    }
  }, true);
});

// Backup approach: Replace existing event listeners
function overrideMobileNavToggle() {
  const toggleButtons = document.querySelectorAll('.mobile-nav-toggle');
  
  toggleButtons.forEach(button => {
    const newButton = button.cloneNode(true);
    button.parentNode.replaceChild(newButton, button);
    
    newButton.addEventListener('click', function(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      evt.stopImmediatePropagation();
      
      const mobileMenu = document.querySelector('mobile-menu');
      if (mobileMenu && typeof mobileMenu.toggle === 'function') {
        mobileMenu.toggle();
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(overrideMobileNavToggle, 100);
  });
} else {
  setTimeout(overrideMobileNavToggle, 100);
}